import axios from 'axios';
import { useSelector } from 'react-redux';
import store from '../redux/store/store';
const API_ECOMMERCEPLACE_URL = import.meta.env.VITE_API_URL;
const API_CC = import.meta.env.VITE_CC_URL;
const ecommercePlaceService = {




//Market hesap bilgilerini getirir 
getEcommercePlaceAccountsApi: (userId,token) => {
  const userToken = store.getState()?.auth?.user?.accessToken?.token;
  return axios.get(`${API_ECOMMERCEPLACE_URL}/EcommercePlaceSetting?UserId=${userId}`,{
    headers: {
      Authorization: `Bearer ${userToken}`},
    });
},

//Marketleri getir 
getEcommercePlaceApi: async (token) => {
  try {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    const response = await axios.get(`/EcommercePlace`,{ headers: {
      Authorization: `Bearer ${userToken}`},
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching invoices:', error);
    throw error;
  }
},

addEcommercePlaceApi: (data,token) => {
  const userToken = store.getState()?.auth?.user?.accessToken?.token;
  const postData = data.EcommercePlaceData.map((item) => ({
    UserId: 1,
    ecommercePlaceId: item.ecommercePlaceId,
    ValueId: item.valueId,
    Value: item.value,
    IA:true
  }));
  return axios.post(
    `${API_ECOMMERCEPLACE_URL}/EcommercePlaceSetting/CreateRange`, 
    postData,
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
},

updateEcommercePlaceApi: (data,token) => {
  const userToken = store.getState()?.auth?.user?.accessToken?.token;
  const postData = data.EcommercePlaceData.map((item) => ({
    UserId: 1,
    ecommercePlaceId: item.ecommercePlaceId,
    ValueId: item.valueId,
    Value: item.value,
    IA:true,
    id:item.id
  }));
 
  return axios.put(`${API_ECOMMERCEPLACE_URL}/EcommercePlaceSetting/UpdateRange`, postData,{
    headers: {
      Authorization: `Bearer ${userToken}`,},
    });
},
getEcommercePlacesForCC: () => {
  return axios.get(`${API_CC}/EcommercePlace`,
    {
    headers: {
      UserAgent:'PC'
    },
    auth:{
      username:"CBD0FD46-899D-4915-A1BE-CA7359E346D6",
      password:"CBD0FD46-899D-4915-A1BE-CA7359E346D6"
    }
    });
},
};




export default ecommercePlaceService;
